@if (!isLoading) {
<div>
  <div class="ot-row">
    <div class="otsc-prop-header">
      <h1 class="otsc-prop-header-text" i18n>Logs</h1>
      <div class="ot-btn-group otsc-prop-header-btn">
        <button id="otsc-settings-logs-save-btn" role="button" class="ot-btn ot-btn--is-primary" (click)="save()"
          [disabled]="!settingsForm.dirty || settingsForm.invalid">
          {{savingBtn}}
        </button>
        <button id="otsc-settings-logs-reset-btn" role="button" class="ot-btn ot-btn--is-secondary" (click)="reset()"
          [disabled]="!settingsForm.dirty" i18n>
          Reset
        </button>
      </div>
    </div>
  </div>
  <form [formGroup]="settingsForm" name="otsc-settings-logs-form">
    <div class="ot-pt-1 ot-pb-1 ot-pl-1" style="height: calc(100vh - 150px);">
      <ng-scrollbar #scrollbarRef>
        <div>
          <div class="ot-row">
            <div class="ot-col ot-row__column ot-row__column--is-33">
              <div class="ot-form-control">
                <label for="logLevel" i18n>Log Level</label>
                <div class="ot-select">
                  <select id="logLevel" name="logLevel" formControlName="logLevelCtrl" aria-label="Select log level">
                    <option value="TRACE" i18n>Trace</option>
                    <option value="DEBUG" i18n>Debug</option>
                    <option value="INFO" i18n>Info</option>
                    <option value="ERROR" i18n>Error</option>
                  </select>
                </div>
                <div class="ot-form-control__info-text">
                  <div i18n>
                    Set log level for informational events that are most useful for debugging purposes.
                  </div>
                  <div i18n>
                    The system writes to the &lt;<i>System_Center_installation_folder</i>&gt;/logs/otsc.log file.
                  </div>
                  <div i18n>
                    <b>Note:</b> An agent log level can be set on each System Details view.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ot-row">
            <div class="ot-col ot-row__column ot-row__column--is-33">
              <div class="ot-form-control">
                <label for="httpLogLevel" i18n>HTTP log level</label>
                <div class="ot-select">
                  <select id="httpLogLevel" name="httpLogLevel" formControlName="httpLogLevelCtrl"
                    aria-label="Select HTTP log level">
                    <option value="TRACE" i18n>Trace</option>
                    <option value="DEBUG" i18n>Debug</option>
                    <option value="INFO" i18n>Info</option>
                    <option value="ERROR" i18n>Error</option>
                  </select>
                </div>
                <div class="ot-form-control__info-text">
                  <div i18n>
                    Set log level for HTTP context and full wire logging.
                  </div>
                  <div i18n>
                    The manager writes to the &lt;<i>System_Center_installation_folder</i>&gt;/logs/otsc_http.log file.
                  </div>
                  <div i18n>
                    <b>Note:</b> Increasing the log level may capture sensitive information.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ot-row">
            <div class="ot-col ot-row__column ot-row__column--is-33">
              <div class="ot-form-control">
                <label for="SFTPLogLevelCtrl" i18n>SFTP log level</label>
                <div class="ot-select">
                  <select id="SFTPLogLevelCtrl" name="SFTPLogLevelCtrl" formControlName="SFTPLogLevelCtrl"
                    aria-label="Select SFTP log level">
                    <option value="TRACE" i18n>Trace</option>
                    <option value="DEBUG" i18n>Debug</option>
                    <option value="INFO" i18n>Info</option>
                    <option value="ERROR" i18n>Error</option>
                  </select>
                </div>
                <div class="ot-form-control__info-text">
                  <div i18n>
                    Set log level for SFTP logging.
                  </div>
                  <div i18n>
                    The manager writes to the &lt;<i>System_Center_installation_folder</i>&gt;/logs/otsc_sftp.log file.
                  </div>
                  <div i18n>
                    <b>Note:</b> Increasing the log level may capture sensitive information.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="otsc-settings-req-logging">
          <app-checkbox [identifier]="'requestLogging'" formControlName="requestLoggingCtrl" [name]="'requestLogging'"
            [toggle]="true" i18n-label [label]="'Enable request logging'" i18n-description
            [description]="'Log all incoming requests to the server. <br>The system writes to the &lt;<i>System_Center_installation_folder</i>&gt;/logs/requests_yyyy_mm_dd.log file.'"
            i18n-arialabel [arialabel]="'Enable/disable request logging'">
          </app-checkbox>
          <div class="ot-row">
            <div class="ot-col ot-row__column ot-row__column--is-33">
              <div class="ot-form-control"
                [ngClass]="{'ot-form-control--is-invalid' : requestLoggingCtrl.value == true && requestLoggingRetentionPeriodCtrl.invalid}">
                <label class="ot-form-control__label" for="requestLoggingRetentionPeriod" i18n>
                  Log retention period (days)
                </label>
                <div class="ot-form-control__input-group">
                  <input id="requestLoggingRetentionPeriod" formControlName="requestLoggingRetentionPeriodCtrl"
                    placeholder="Enter retention period" type="number" maxlength="2"
                    class="ot-input ot-input--is-expanded" [readonly]="!requestLoggingCtrl.value">
                  <span class="ot-form-control__error-icon">
                  </span>
                </div>
                @if (requestLoggingRetentionPeriodCtrl.invalid) {
                <p id="invalidLogRetentionPeriodtMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                  Invalid time specified. Please select a time period between 1 and 30 days.
                </p>
                }
                <p class="ot-form-control__info-text" i18n>The value can be set between 1 and 30 days.</p>
              </div>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </div>
  </form>
</div>
} @else {
<div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
  <div class="ot-progress__outer">
    <div class="ot-progress__meter">
    </div>
  </div>
  <div class="ot-progress__text" id="otsc-settings-logs-loading" i18n>Loading...</div>
</div>
}